import { Job } from '../data/jobs';
import { JobCard } from './JobCard';

interface JobListProps {
  jobs: Job[];
  onJobClick: (jobId: string) => void;
  isLoading?: boolean;
  isEmpty?: boolean;
}

export function JobList({ jobs, onJobClick, isLoading = false, isEmpty = false }: JobListProps) {
  if (isLoading) {
    return (
      <div className="flex justify-center items-center py-12">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  if (isEmpty || jobs.length === 0) {
    return (
      <div className="text-center py-12">
        <p className="text-gray-500 text-lg">No se encontraron vacantes. Intenta nuevamente ajustando los criterios de búsqueda.</p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 gap-4 max-w-4xl mx-auto">
      {jobs.map((job) => (
        <JobCard key={job.id} job={job} onClick={onJobClick} />
      ))}
    </div>
  );
}
